/**
 * User: Keith
 * Author: Faris
 * Date: 6/24/15
 * Time: 10:30 AM
 */

define('app/views/map',['require','./page','text!../../../views/map.html'],function(require) {

  var Page = require('./page');  
  var template = require('text!../../../views/map.html');

  return Page.extend({
	 template: _.template(template),
	 
	 initialize: function(options){
	 },
	 
	 onPageLoaded: function() {
		
	 },
	 
	 transitionInComplete: function() {
		 this.generateMap();
	 },
 
	 generateMap: function() {		 
		 var latitude = this.model.get("LATITUDE");
		 var longitude = this.model.get("LONGITUDE");
		 
		 // Find offset amount
		 var offset = 0;
		 if($(window).width()>768) 
		     offset = .005
		 
		 //Basic options for a simple Google Map
		 // For more options see: https://developers.google.com/maps/documentation/javascript/reference#MapOptions
		 var mapOptions = {
			// How zoomed in you want the map to start at (always required)
			zoom: 15,
			
			// The latitude and longitude to center the map (always required)
			center: new google.maps.LatLng(latitude, longitude+offset),
			
			// How you would like to style the map. 
			// This is where you would paste any style found on Snazzy Maps.
			styles: [{"featureType":"administrative.land_parcel","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"landscape.man_made","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels","stylers":[{"visibility":"simplified"},{"lightness":20}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"hue":"#f49935"}]},{"featureType":"road.highway","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"hue":"#fad959"}]},{"featureType":"road.arterial","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"visibility":"simplified"}]},{"featureType":"road.local","elementType":"labels","stylers":[{"visibility":"simplified"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"hue":"#a1cdfc"},{"saturation":30},{"lightness":49}]}],
			
			// Controls
			panControl: false,
			streetViewControl: false,
			mapTypeControl: false,
			zoomControl: false,
			zoomControlOptions: {
			    position: google.maps.ControlPosition.RIGHT_TOP
			}
		 };

		// Get the HTML DOM element that will contain your map 
		// We are using a div with id="map" seen below in the <body>
		var mapElement = document.getElementById('map');

		// Create the Google Map using our element and options defined above
		var map = new google.maps.Map(mapElement, mapOptions);
		
		var url = '/images/mapMarker.png';
		var size = new google.maps.Size(179, 104);
		
		// Check for retina
		if(window.devicePixelRatio > 1.5){
	        url = '/images/mapMarkerRetina.png';
	    }

		var image = {
	        url: url,
	        size: size,
	        scaledSize: new google.maps.Size(178, 104),
	        origin: new google.maps.Point(0,0),
	        anchor: new google.maps.Point(89, 104)
	    };
		
		var marker = new google.maps.Marker({
		    position: new google.maps.LatLng(latitude, longitude),
		    map: map,
		    title: 'Loft 523',
		    icon: image
		});
		
		this.map = map;
         
	 }
  });
});

